<template>
  <v-card
    :key="'generic_' + generic.id"
    style="border-radius: 10px; overflow: hidden"
    class="card ml-1 mr-1 generic-card"
    :style="{
      width: size == 'big' ? '300px' : checkIcon ? '100px' : '200px'
    }"
  >
    <div
      class="card-img"
      :style="{
        height:
          (size == 'big' ? '300' : checkIcon ? '100' : '200') / (ratio == 'horizontal' ? 1.91 : 1) +
          'px'
      }"
      style="border-bottom: 1px solid #eee"
    >
      <template v-if="generic.productid && currentProduct.photourl">
        <div v-if="loadingProduct" class="text-xs-center">
          <pulse-loader :color="$vuetify.theme.primary" :size="'15px'"></pulse-loader>
        </div>
        <div
          v-else
          :style="{
            height: (size == 'big' ? '300' : '200') / (ratio == 'horizontal' ? 1.91 : 1) + 'px',
            'background-image': 'url(\'' + currentProduct.photourl + '\')'
          }"
          style="
            width: 100%;
            height: 100%;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
          "
        ></div>
      </template>
      <template v-else-if="generic.image_url">
        <div
          :style="{
            height:
              (size == 'big' ? '300' : checkIcon ? '100' : '200') /
                (ratio == 'horizontal' ? 1.91 : 1) +
              'px',
            'background-image': 'url(\'' + generic.image_url + '\')',
            'background-size': `${checkIcon ? '65%' : 'cover'}`
          }"
          style="
            width: 100%;
            height: 100%;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
          "
        ></div>
        <!-- <img class="card-img-top" :src="generic.image_url"  > -->
      </template>

      <template v-else>
        <div
          :style="{
            height: (size == 'big' ? '300' : '200') / (ratio == 'horizontal' ? 1.91 : 1) + 'px',
            'background-image': 'url(\'/static/img/assets/generic/generic_default_thumbnail.png\')'
          }"
          style="
            width: 100%;
            height: 100%;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
          "
        ></div>
      </template>
    </div>

    <div
      class="card-body"
      style="padding: 0px 8px; overflow: hidden"
      :style="{
        height: size == 'small' ? (checkIcon ? '20px' : '120px') : '120px'
      }"
    >
      <h4
        style="font-weight: 600"
        :style="{
          'font-size': size == 'big' ? 'inherit' : '12px',
          margin: checkIcon ? '0px' : '10px 0px'
        }"
      >
        <template v-if="generic.productid">
          <div v-if="loadingProduct" class="text-xs-center">
            <pulse-loader :color="$vuetify.theme.primary" :size="'15px'"></pulse-loader>
          </div>
          <template v-else>
            <specialtext :text="currentProduct.name" :truncate="40"></specialtext>
          </template>
        </template>
        <template v-else-if="generic.title">
          <specialtext :text="generic.title" :truncate="40"></specialtext>
        </template>
        <template v-else>No Text</template>
      </h4>

      <p :style="{ 'font-size': size == 'big' ? 'inherit' : '12px' }" style="overflow: hidden">
        <template v-if="generic.productid">
          <div v-if="loadingProduct" class="text-xs-center">
            <pulse-loader :color="$vuetify.theme.primary" :size="'15px'"></pulse-loader>
          </div>
          <template v-else>
            <specialtext :text="currentProduct.description" :truncate="90"></specialtext>
          </template>
        </template>
        <template v-else-if="generic.subtitle">
          <specialtext :text="generic.subtitle" :truncate="90"></specialtext>
        </template>
        <template v-else>No Text</template>
      </p>
    </div>

    <div class="card-footer">
      <ul class="list-group list-group-flush" style="margin-bottom: 0px">
        <template v-if="generic.buttons.length > 0">
          <li
            v-for="(button, bindex) in generic.buttons"
            :key="bindex"
            class="list-group-item"
            style="border: none; border-top: 1px solid #eee; border-radius: 0px; text-align: center"
            :style="{ padding: size == 'small' ? '5px 0' : '10px 0' }"
          >
            <template v-if="button">
              <span style="color: #0084ff">
                <template v-if="button.type == 'web_url'">
                  <a
                    v-if="isURL(button.url)"
                    :href="button.url"
                    target="_blank"
                    rel="noopener noreferrer"
                    >{{ button.title | truncate(20) }}
                  </a>
                  <div v-else class="primary--text">
                    {{ button.title | truncate(20) }}
                  </div>
                </template>

                <template v-else>
                  <span
                    v-clipboard:copy="button.title"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onCopyError"
                    style="cursor: pointer"
                  >
                    {{ button.title | truncate(20) }}
                  </span>
                </template>
              </span>
              <div style="margin: 0; font-size: 10px; color: #969595">
                <span v-if="button.type == 'web_url'" :title="button.url">{{
                  button.url | truncate(20)
                }}</span>
                <span
                  v-else-if="button.type == 'postback'"
                  v-clipboard:copy="button.payload"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onCopyError"
                  style="cursor: pointer"
                  :title="button.payload"
                  >{{ button.payload | truncate(20) }}</span
                >
                <span v-else-if="button.type == 'phone_number'" :title="button.payload">{{
                  button.payload | truncate(20)
                }}</span>
                <span v-else>&nbsp;</span>
              </div>
            </template>
          </li>
        </template>
        <template v-else>
          <li
            class="list-group-item"
            style="border: none; border-top: 1px solid #eee; border-radius: 0px; text-align: center"
            :style="{ padding: size == 'small' ? '5px 0' : '15px 0' }"
          >
            <span>-</span>
          </li>
        </template>
      </ul>
    </div>
    <v-snackbar v-model="showCopy" :timeout="6000" color="green" :top="true"
      >{{ $t('Copied') }}!</v-snackbar
    >
  </v-card>
</template>

<script>
import specialtext from '@/components/elements/specialtext'
import { mapGetters } from 'vuex'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
  components: {
    specialtext,
    PulseLoader
  },
  props: {
    generic: [Object, String, Array],
    size: {
      type: String,
      default: 'big'
    },
    ratio: {
      default: 'square'
    }
  },
  data() {
    return {
      showCopy: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      products: 'getProducts',
      loadingProduct: 'getLoadingProduct'
    }),
    checkIcon() {
      const vm = this
      return (
        vm.generic.image_url === 'https://cms.zwiz.app/static/img/assets/icon/file.png' ||
        vm.generic.image_url === 'https://cms.zwiz.app/static/img/assets/icon/pdf.png' ||
        vm.generic.image_url === 'https://cms.zwiz.app/static/img/assets/icon/pdf.svg' ||
        vm.generic.image_url === 'https://cms.zwiz.app/static/img/assets/icon/xls.png' ||
        vm.generic.image_url === 'https://cms.zwiz.app/static/img/assets/icon/word.png' ||
        vm.generic.image_url === 'https://cms.zwiz.app/static/img/assets/icon/powerpoint.png'
      )
    },
    currentProduct: function () {
      var vm = this
      if (this.$store.state.shoptheme.includes(vm.selectedBot.theme)) {
        if (vm.generic.productid) {
          return vm.products.find(function (val) {
            return val.id == vm.generic.productid
          })
        }
      }
      return false
    },
    onCopyError: function () {}
  },
  methods: {
    onCopy: function () {
      let vm = this

      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 3000)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/GenericViewerItem.vue